module.exports = __webpack_public_path__ + "img/whimsey-necklace-5.071baf3f.jpg";